import { BoardConst, JSON_DIR_TO_CONST } from './constants.js';

export interface PieceType {
    type_id: number;
    name: string;
    steps: Map<BoardConst, number>;
    jump_positions: Array<[number, number]>;
    ability: string | null;
    rank: number;
    promotion_id: number;
    value: number;
    reading: string;
    glyph: string | null;
    can_promote: boolean;
}

export interface PlacementEntry {
    x: number;
    y: number;
    piece_instance_id: number;
    piece_type_id: number;
}

export function load_piece_types(raw: any): Map<number, PieceType> {
    const types = new Map<number, PieceType>();
    for (const type_id_str of Object.keys(raw)) {
        const type_id = parseInt(type_id_str, 10);
        const data = raw[type_id_str];
        
        const steps = new Map<BoardConst, number>();
        for (const [json_key, bc] of Object.entries(JSON_DIR_TO_CONST)) {
            steps.set(bc, data[json_key] || 0);
        }
        
        const jump_positions: Array<[number, number]> = (data.jump_positions || []).map((p: number[]) => [p[0], p[1]]);
        const name = data.name || '';
        let val = data.value || 0;
        if (name === '玉将') {
            val += 50000;
        } else if (name === '太子') {
            val += 30000;
        }
        
        types.set(type_id, {
            type_id: type_id,
            name: name,
            steps: steps,
            jump_positions: jump_positions,
            ability: data.ability || null,
            rank: data.rank || 0,
            promotion_id: data.promotion_id !== undefined ? data.promotion_id : -1,
            value: val,
            reading: data.reading || '',
            glyph: data.glyph || null,
            can_promote: data.promotion_id !== undefined && data.promotion_id >= 0
        });
    }
    return types;
}

export function load_placements(raw: any[]): PlacementEntry[] {
    return raw.map(entry => ({
        x: entry.x,
        y: entry.y,
        piece_instance_id: entry.piece_instance_id,
        piece_type_id: entry.piece_type_id
    }));
}
